/**
 * It sorts tags in the following order
 * AI, first to the left
 * Emergency, second to the left (after AI if present)
 * Non-Patient, next priority
 * New Patient, next priority
 * Current Patient, next priority
 * Eg. [AI] [Emergency] [Non-Patient] [New Patient] [Current Patient] [Regular Tags]
 *
 * @param tags string[] | undefined
 * @returns custom sorted tags
 */
export function sortTags(tags: string[] | undefined) {
  if (!tags) return []

  // Keep the existing priority ordering, but sort the remaining tags lexicographically.
  // Note: this function is used widely across the app; ensure changes are intentional.

  const priorityOrder = [`Archived`, `AI`, `Emergency`, `Non-Patient`, `New Patient`, `Current Patient`]

  const priorityTags: { tag: string; index: number }[] = []
  const regularTags: { tag: string; index: number }[] = []

  tags.forEach((tag, index) => {
    if (priorityOrder.includes(tag)) {
      priorityTags.push({ tag, index })
    } else {
      regularTags.push({ tag, index })
    }
  })

  priorityTags.sort((a, b) => {
    const byPriority = priorityOrder.indexOf(a.tag) - priorityOrder.indexOf(b.tag)
    if (byPriority !== 0) return byPriority

    // Preserve original order for duplicates of the same priority tag.
    return a.index - b.index
  })

  regularTags.sort((a, b) => {
    const byTag = a.tag.localeCompare(b.tag)
    if (byTag !== 0) return byTag

    // Preserve original order for duplicates.
    return a.index - b.index
  })

  return [...priorityTags, ...regularTags].map(({ tag }) => tag)
}
